import styled from "@emotion/styled";
import { Block as F7Block } from "framework7-react";

export const LegendBar = styled(F7Block)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0;
`;
